import { render, staticRenderFns } from "./RemarkDetailPopup.vue?vue&type=template&id=7f751151&scoped=true&"
import script from "./RemarkDetailPopup.vue?vue&type=script&lang=js&"
export * from "./RemarkDetailPopup.vue?vue&type=script&lang=js&"
import style0 from "./RemarkDetailPopup.vue?vue&type=style&index=0&id=7f751151&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f751151",
  null
  
)

export default component.exports